<footer>
  <div class="image">
    <img src="/assets/img/movesion_mobility_tomorrow.svg" alt="MOVESION MOBILITY TOMORROW" class="imgmobilitytomorrow">
  </div>
  <div>
    <a href="#" class="credit">&copy; {{currentYear}} MOVESION | Privacy & Cookie Policy</a>
  </div>
  <div><a class="link-movision" href="https://www.movesion.com/" target="_blank">movesion.com</a></div>
</footer>
